import _ from 'lodash';
import { IntlShape } from 'react-intl';

import { isValidEmail } from '../../../../validation/common';
import {
  TeamMember,
  TeamMemberAccess,
  TeamMemberFormValues,
} from '../../team.types';

import { MultiSelectTag } from '@wix/design-system';

export const validateSecurityGroups = (
  securityGroups: TeamMemberAccess[],
  intl,
) => {
  return securityGroups.map((group: TeamMemberAccess, idx) => {
    if (!group.level) {
      return intl.formatMessage({
        id: 'team.add-member-modal.form.access-groups.error-message',
      });
    }

    return undefined;
  });
};

export const validateEmails = (
  emailsOptions: MultiSelectTag[],
  intl: IntlShape,
  members: TeamMember[],
): string | undefined => {
  const emails = _.map(emailsOptions, 'id');

  if (_.isEmpty(emails)) {
    return intl.formatMessage({
      id: 'team.add-member-modal.form.emails.error-message.empty-field',
    });
  }

  const invalidEmails = _.filter(emails, (email) => !isValidEmail(email));

  if (_.size(invalidEmails) > 0) {
    return intl.formatMessage({
      id: 'team.add-member-modal.form.emails.error-message.invalid-emails',
    });
  }

  const alreadyExistingEmails = _.filter(emails, (email) =>
    _.some(members, (member) => {
      return member.primaryEmail.address === email;
    }),
  );

  if (_.size(emails) === 1 && _.size(alreadyExistingEmails) === 1) {
    return intl.formatMessage({
      id: 'team.add-member-modal.form.emails.error-message.already-exist-one-member',
    });
  }

  if (_.size(alreadyExistingEmails) === 1) {
    return intl.formatMessage(
      {
        id: 'team.add-member-modal.form.emails.error-message.already-exist-member',
      },
      {
        email: alreadyExistingEmails[0],
      },
    );
  }

  if (_.size(alreadyExistingEmails) > 1) {
    return intl.formatMessage(
      {
        id: 'team.add-member-modal.form.emails.error-message.already-exist-members',
      },
      {
        emails: _.join(alreadyExistingEmails, ', '),
      },
    );
  }

  return;
};

export const validateTeamMemberForm =
  (intl: IntlShape, members: TeamMember[]) =>
  (value: TeamMemberFormValues): any => {
    const errors = {
      securityGroups: validateSecurityGroups(value.securityGroups, intl),
      emails: validateEmails(value.emails, intl, members),
    };

    return errors;
  };
